export const ContextMenuItems = {
  editProduct: { id: 'edit-product', label: 'Edit Product' },
  configurePolicies: { id: 'configure-policies', label: 'Configure Policies' },
};
